export const mockFactoryUser = {
  id: "factory-001",
  companyName: "GreenGrow USA Manufacturing",
  email: "contact@greengrow-usa.com",
  phone: "+1 (503) 555-0192",
  country: "USA",
  warehouse: "Portland, OR",
  verified: true,
  joinedDate: "2024-03-15",
  avatar: "https://public.readdy.ai/ai/img_res/1921fa1a3463fb8765447bd3907a8b35.jpg",
};

export const mockFactoryStats = {
  totalProducts: 24,
  activeListings: 18,
  totalOrders: 312,
  pendingOrders: 7,
  monthlyRevenue: 48320,
  totalRevenue: 284750,
  rating: 4.8,
  reviewCount: 156,
};

export const mockFactoryProducts = [
  {
    id: "fp-001",
    name: "Steel Raised Garden Bed Kit 4x8ft",
    category: "Garden",
    price: 89.99,
    stock: 240,
    minOrder: 10,
    status: "active",
    sales: 87,
    image: "https://readdy.ai/api/search-image?query=steel%20raised%20garden%20bed%20kit%20galvanized%20metal%20outdoor%20planter%20USA%20made%20clean%20white%20background%20product%20photo&width=200&height=200&seq=fp001&orientation=squarish",
    sku: "GG-SRB-48",
    warehouse: "USA",
  },
  {
    id: "fp-002",
    name: "Heavy Duty Garden Hose 100ft",
    category: "Garden",
    price: 54.99,
    stock: 520,
    minOrder: 20,
    status: "active",
    sales: 143,
    image: "https://readdy.ai/api/search-image?query=heavy%20duty%20green%20garden%20hose%20100ft%20coiled%20outdoor%20USA%20made%20clean%20white%20background%20product%20photo&width=200&height=200&seq=fp002&orientation=squarish",
    sku: "GG-HGH-100",
    warehouse: "USA",
  },
  {
    id: "fp-003",
    name: "Cast Iron Garden Bench",
    category: "Garden",
    price: 219.99,
    stock: 45,
    minOrder: 5,
    status: "active",
    sales: 32,
    image: "https://readdy.ai/api/search-image?query=cast%20iron%20garden%20bench%20outdoor%20furniture%20black%20ornate%20USA%20made%20clean%20white%20background%20product%20photo&width=200&height=200&seq=fp003&orientation=squarish",
    sku: "GG-CIB-01",
    warehouse: "USA",
  },
  {
    id: "fp-004",
    name: "Compost Tumbler 37 Gallon",
    category: "Garden",
    price: 129.99,
    stock: 88,
    minOrder: 5,
    status: "inactive",
    sales: 19,
    image: "https://readdy.ai/api/search-image?query=compost%20tumbler%20barrel%20garden%20outdoor%20green%20USA%20made%20clean%20white%20background%20product%20photo&width=200&height=200&seq=fp004&orientation=squarish",
    sku: "GG-CT-37",
    warehouse: "USA",
  },
  {
    id: "fp-005",
    name: "10-Piece Garden Tool Set",
    category: "Garden",
    price: 74.99,
    stock: 310,
    minOrder: 15,
    status: "active",
    sales: 201,
    image: "https://readdy.ai/api/search-image?query=10%20piece%20garden%20tool%20set%20stainless%20steel%20trowel%20rake%20USA%20made%20clean%20white%20background%20product%20photo&width=200&height=200&seq=fp005&orientation=squarish",
    sku: "GG-GTS-10",
    warehouse: "USA",
  },
  {
    id: "fp-006",
    name: "Solar LED Path Lights Set of 12",
    category: "Garden",
    price: 49.99,
    stock: 0,
    minOrder: 20,
    status: "out_of_stock",
    sales: 98,
    image: "https://readdy.ai/api/search-image?query=solar%20LED%20path%20lights%20garden%20outdoor%20stainless%20steel%20USA%20made%20clean%20white%20background%20product%20photo&width=200&height=200&seq=fp006&orientation=squarish",
    sku: "GG-SPL-12",
    warehouse: "USA",
  },
];

export const mockFactoryOrders = [
  {
    id: "ORD-2026-0411",
    buyer: "TechMart Wholesale",
    buyerCountry: "USA",
    product: "Steel Raised Garden Bed Kit 4x8ft",
    qty: 50,
    total: 4499.50,
    status: "processing",
    date: "2026-04-11",
    paymentStatus: "paid",
    shippingAddress: "1200 Commerce Blvd, Dallas, TX 75201",
  },
  {
    id: "ORD-2026-0409",
    buyer: "GardenPro Canada",
    buyerCountry: "Canada",
    product: "10-Piece Garden Tool Set",
    qty: 100,
    total: 7499.00,
    status: "shipped",
    date: "2026-04-09",
    paymentStatus: "paid",
    shippingAddress: "450 King St W, Toronto, ON M5V 1K4",
  },
  {
    id: "ORD-2026-0407",
    buyer: "HomeBase Distributors",
    buyerCountry: "USA",
    product: "Heavy Duty Garden Hose 100ft",
    qty: 200,
    total: 10998.00,
    status: "delivered",
    date: "2026-04-07",
    paymentStatus: "paid",
    shippingAddress: "800 Industrial Ave, Chicago, IL 60601",
  },
  {
    id: "ORD-2026-0405",
    buyer: "Maple Leaf Retail",
    buyerCountry: "Canada",
    product: "Cast Iron Garden Bench",
    qty: 20,
    total: 4399.80,
    status: "delivered",
    date: "2026-04-05",
    paymentStatus: "paid",
    shippingAddress: "200 Granville St, Vancouver, BC V6C 1S4",
  },
  {
    id: "ORD-2026-0402",
    buyer: "SunGarden LLC",
    buyerCountry: "USA",
    product: "Compost Tumbler 37 Gallon",
    qty: 30,
    total: 3899.70,
    status: "cancelled",
    date: "2026-04-02",
    paymentStatus: "refunded",
    shippingAddress: "500 Market St, San Francisco, CA 94105",
  },
  {
    id: "ORD-2026-0330",
    buyer: "NorthWest Supplies",
    buyerCountry: "USA",
    product: "Solar LED Path Lights Set of 12",
    qty: 80,
    total: 3999.20,
    status: "delivered",
    date: "2026-03-30",
    paymentStatus: "paid",
    shippingAddress: "300 Pine St, Seattle, WA 98101",
  },
  {
    id: "ORD-2026-0328",
    buyer: "Prairie Garden Co.",
    buyerCountry: "Canada",
    product: "10-Piece Garden Tool Set",
    qty: 60,
    total: 4499.40,
    status: "delivered",
    date: "2026-03-28",
    paymentStatus: "paid",
    shippingAddress: "100 Main St, Calgary, AB T2P 1B2",
  },
];

export const categories = [
  "Garden", "Electronics", "Fashion", "Beauty", "Home Goods", "Sports", "Toys", "Food", "Tools", "Furniture"
];
